"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Animation = void 0;
var _react = _interopRequireDefault(require("react"));
var _lottieReact = require("lottie-react");
var _Animations = require("./Animations");
var _styledComponents = require("styled-components");
var _jsxRuntime = require("react/jsx-runtime");
var Animation = function Animation(_ref) {
  var animation = _ref.animation; // Set by storybook/chromatic to disable animation looping for visual testing
  var animationNoLoop = window['animationNoLoop'];
  var theme = (0, _styledComponents.useTheme)();
  var themeName = theme.themeName;
  var options = {
    animationData: _Animations.animations[animation][themeName],
    loop: !animationNoLoop
  };
  var _ref2 = (0, _lottieReact.useLottie)(options),
    View = _ref2.View;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: View
  });
};
exports.Animation = Animation;